import type { JSX } from 'react';

import type { ErrorHandlerProps } from '../pageContext';

export function StarterDashboardCommentsErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for StarterDashboardComments page (error: ${error})`);
}
